import { Heading } from "@aws-amplify/ui-react";
import React from "react";
import { Question } from "../../../API";

interface QuestionItemTextProps {
  question: Question | null | undefined;
}

export default function QuestionItemText({
  question,
}: QuestionItemTextProps): JSX.Element {
  return <Heading padding={"xxxs"}>{question?.text}</Heading>;
}
